import { CalcHoursWorkedMode } from "@modules/dialogs/calc-hours-worked-dialog/calc-hours-worked-dialog.component";

export interface CalcHoursWorkedDialog {
	showSourceOption: boolean;
	autoUseHoursWorked: boolean;
	hasWorkSchedules: boolean;
	hasWorkHours: boolean;
}

export enum CalcHoursWorkedSource {
	hoursWorked = 1,
	workSchedule = 2
}

export interface PostCalcHoursWorked {
	confirm: boolean;
	mode: CalcHoursWorkedMode;
	caseId: number;
	source: CalcHoursWorkedSource; //nullable
}

export interface PostCalcHoursWorkedRes {
	calcDetails: string[]; //nullable
	calcMissingDetails: string[]; //nullable
}